"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMP = function FlagMP(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,114.58A102.52,102.52,0,0,1-90.6,12.18,102.51,102.51,0,0,1,11.8-90.22,102.51,102.51,0,0,1,114.2,12.18,102.52,102.52,0,0,1,11.8,114.58ZM11.8-69A81.31,81.31,0,0,0-69.41,12.18,81.3,81.3,0,0,0,11.8,93.39,81.3,81.3,0,0,0,93,12.18,81.31,81.31,0,0,0,11.8-69Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,107.52A95.45,95.45,0,0,1-83.54,12.18,95.45,95.45,0,0,1,11.8-83.16a95.45,95.45,0,0,1,95.34,95.34A95.45,95.45,0,0,1,11.8,107.52Zm0-183.62A88.38,88.38,0,0,0-76.48,12.18,88.38,88.38,0,0,0,11.8,100.46a88.37,88.37,0,0,0,88.27-88.28A88.37,88.37,0,0,0,11.8-76.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,12.18A7.06,7.06,0,0,1-80,19.24a7.06,7.06,0,0,1-7.06-7.06A7.06,7.06,0,0,1-80,5.12a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.67,12.18a7.06,7.06,0,1,1-7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.86-79.63a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-46.06-52.74a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M83.78-52.74a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M103.68-23a7.06,7.06,0,0,1-7.06,7.07A7.06,7.06,0,0,1,89.55-23,7.06,7.06,0,0,1,96.62-30,7.06,7.06,0,0,1,103.68-23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-16.27-72.64a7.08,7.08,0,0,1-7.07,7.07,7.07,7.07,0,0,1-7.06-7.07,7.06,7.06,0,0,1,7.06-7.06,7.07,7.07,0,0,1,7.07,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.95-23A7.07,7.07,0,0,1-73-15.89,7.06,7.06,0,0,1-80.08-23,7.06,7.06,0,0,1-73-30,7.07,7.07,0,0,1-65.95-23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54-72.64a7.07,7.07,0,0,1-7.06,7.07,7.07,7.07,0,0,1-7.07-7.07,7.06,7.06,0,0,1,7.07-7.06A7.06,7.06,0,0,1,54-72.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M108.9-5.73a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.07,7.07,0,0,1,7.06-7.07,7.07,7.07,0,0,1,7.06,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1-77.86A7.06,7.06,0,0,1-6.11-70.8a7.07,7.07,0,0,1-7.07-7.06,7.07,7.07,0,0,1,7.07-7.06A7.06,7.06,0,0,1,1-77.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-57.47-38.83a7.07,7.07,0,0,1-7.07,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.07,7.07,0,0,1,7.07,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.87-64.15a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M95.19-38.83a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-32.15-64.15a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-71.18-5.73a7.06,7.06,0,0,1-7.06,7.06A7.06,7.06,0,0,1-85.3-5.73a7.07,7.07,0,0,1,7.06-7.07,7.07,7.07,0,0,1,7.06,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.77-77.86a7.06,7.06,0,0,1-7.06,7.06,7.06,7.06,0,0,1-7.06-7.06,7.06,7.06,0,0,1,7.06-7.06,7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffdc00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M103.6,15.71a3.54,3.54,0,0,1-3.53-3.53A88.37,88.37,0,0,0,11.8-76.1,88.38,88.38,0,0,0-76.48,12.18,3.53,3.53,0,0,1-80,15.71a3.53,3.53,0,0,1-3.53-3.53A95.45,95.45,0,0,1,11.8-83.16a95.45,95.45,0,0,1,95.34,95.34,3.53,3.53,0,0,1-3.54,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffa000"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.42,118.11H-7.82a14.12,14.12,0,0,1-14-15.6L-9.39-16.07H33L45.47,102.51a14.13,14.13,0,0,1-14,15.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.78-16.07H-9.35A3.64,3.64,0,0,1-13-19.31L-15.6-43.55a7.06,7.06,0,0,1,7-7.83H32.18a7.07,7.07,0,0,1,7,7.83L36.59-19.48a3.84,3.84,0,0,1-3.81,3.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#aaa"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.43-43.15,26.53-5.49l39.86.81a1.73,1.73,0,0,1,1,3.11L35.63,22.52,47.18,60.69a1.73,1.73,0,0,1-2.65,1.92L11.8,39.83-20.93,62.61a1.73,1.73,0,0,1-2.64-1.92L-12,22.52-43.8-1.57a1.73,1.73,0,0,1,1-3.11l39.86-.81L10.16-43.15a1.73,1.73,0,0,1,3.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMP;
exports["default"] = _default;